import { render, staticRenderFns } from "./PartnershipGroup.vue?vue&type=template&id=3c152ba2&"
import script from "./PartnershipGroup.vue?vue&type=script&lang=js&"
export * from "./PartnershipGroup.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports